module.exports = __webpack_public_path__ + "img/Rolling-1s-200px.9c28bf0b.gif";